import {
  AppShell as CLAppShell,
  useTheme,
  useWindowProperties,
} from '@qred/components-library';
import React, { FC } from 'react';
import { isInIframe } from '~/iframeMode';
import { MainContainer } from '~/styles/BaseStyledComponents';
import Header from '../Header/Header';

interface AppShellProps {
  children: React.ReactNode;
  background?: React.CSSProperties['background'];
  backgroundOpacity?: React.CSSProperties['opacity'];
  backgroundColor?: React.CSSProperties['backgroundColor'];
}

const AppShell: FC<AppShellProps> = ({
  children,
  background,
  backgroundOpacity,
  backgroundColor,
}) => {
  const theme = useTheme();
  const { isMobile } = useWindowProperties();
  const defaultBackgroundColor = isMobile
    ? theme.fn.themeColor('Page/Option_1_(White)')
    : theme.fn.themeColor('Page/Option_4_(Greige)');

  return (
    <MainContainer
      $background={background}
      $backgroundOpacity={backgroundOpacity}
      $backgroundColor={backgroundColor ?? defaultBackgroundColor}
      $isInIframe={isInIframe}
    >
      <CLAppShell
        header={isInIframe ? undefined : <Header />}
        mainProps={{
          display: 'flex',
          p: 0,
          miw: '320px',
          style: {
            backgroundColor: 'inherit',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100%',
          },
        }}
      >
        {children}
      </CLAppShell>
    </MainContainer>
  );
};

export default AppShell;
